import dynamic from 'next/dynamic'

export const DynamicProductPageLatestActivity = dynamic(
  async () =>
    import('./ProductPageLatestActivityContent').then(
      (mod) => mod.ProductPageLatestActivityContent,
    ),
  {
    ssr: false,
  },
)
